import { marketPlaceBaseQueryWrapper } from "@/utils/rtkHelper";
import { createApi } from "@reduxjs/toolkit/query/react";

export const subSkuGroupApi = createApi({
  reducerPath: "subSkuGroup",
  baseQuery: marketPlaceBaseQueryWrapper,
  tagTypes: ["subSkuGroup"],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    // getSubSku: builder.query({
    //   query: ({ search }) => {
    //     const params = new URLSearchParams();
    //     console.log(search);
    //     if (search && search.length > 0) {
    //       params.set("search", search);
    //     }
    //     return `/subSku?${params.toString()}`;
    //   },
    //   providesTags: ["subSku"],
    // }),
    getSubSkuGroupById: builder.query<any, any>({
      query: ({ id }) => `/subSkugroup/get_by_id/${id}`,
      providesTags: ["subSkuGroup"],
    }),
    createSubSkuGroup: builder.mutation<void, any>({
      query: (input) => ({
        url: `/subSkugroup`,
        method: "POST",
        body: input,
      }),
      invalidatesTags: ["subSkuGroup"],
    }),
    getSubSkuBySkuId: builder.query<any, any>({
      query: ({ id }) => `/subSkugroup/skugroup/${id}`,
      providesTags: ["subSkuGroup"],
    }),
    updateSubSkuGroup: builder.mutation<void, any>({
      query: ({ id, data }) => ({
        url: `/subSkugroup/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["subSkuGroup"],
    }),
    deleteSubSkuGroup: builder.mutation<void, any>({
      query: ({ id }) => ({
        url: `/subSkugroup/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["subSkuGroup"],
    }),
  }),
});

export const {
  useCreateSubSkuGroupMutation,
  useGetSubSkuBySkuIdQuery,
  useUpdateSubSkuGroupMutation,
  useGetSubSkuGroupByIdQuery,
  useDeleteSubSkuGroupMutation
} = subSkuGroupApi;
